module.exports = {
	// header
	header: {
		welcome: 'Welcome to paijie. Have a good time!',
		test: {
			final: 'Enter official edition',
			beta: 'Enter beta version'
		},
		login: 'Login',
		me: 'Me',
		log_out: 'Log Out',
		customer_service: 'Customer Service',
		search: 'search',
		nav: {
			home: 'HOME',
			subject: 'SUBJECT',
			auction: 'AUCTION',
			auction_notice: 'AUCTION NOTICE',
			notice: 'NOTICE',
			enterprise: 'ENTERPRISE',
			about_us: 'ABOUT US',
			note: 'Bulletin'
		}
	},
	// footer
	footer: {
		problems: {
			FAQs_and_process: {
				title: 'FAQs and Auction process',
				list_1: 'How to sign up for bidding?',
				list_2: 'What is Flow beat?',
				list_3: 'What is Subject matter?'
			},
			auction_rules: {
				title: 'Auction rules',
				list_1: 'Margin rules?',
				list_2: 'Auction rules?',
				list_3: 'Auction delay rule?',
				list_4: 'Re auction rules?'
			},
			other_FAQs: {
				title: 'Other FAQs',
				list_1: 'What about regretting participating in the auction?',
				list_2: 'How to handle asset delivery?'
			},
			institutional_presence: {
				title: 'Institutional presence',
				list_1: 'paijie official'
			},
			official_wechat: {
				title: 'Official Wechat'
			},
			about_us: {
				title: 'About us',
				list_1: 'National hotline:',
				list_2: '400-9005-905',
				list_3: 'Address: 2507 Yatai Street, Nanguan District, Changchun City, Jilin Province'
			}
		},
		keep_on_record: {
			nav: {
				home: 'HOME',
				subject: 'SUBJECT',
				notice: 'NOTICE',
				enterprise: 'ENTERPRISE'
			},
			License_No: 'License No.',
			MIIT: 'MIIT keep on record',
			copyright: 'paijie all rights reserved'
		}
	},
	// login
	login: {
		welcome: 'Welcome',
		phone: 'phone number',
		code: 'code',
		send_code: 'send code',
		reacquire: 'reacquire',
		submit: 'Sign in / register',
		phone_error: 'Incorrect format of mobile number'
	},
	// 首页
	home: {
		class: {
			title: 'Auction classification',
			used_equipment: 'used equipment',
			construction_machinery: 'construction machinery',
			scrap_metal: 'scrap_metal',
			waste_precious_metal: 'waste precious metal',
			waste_paper: 'waste paper',
			packing: 'packing',
			printing: 'printing',
			overstock_of_goods: 'overstock of goods',
			hazardous_chemical_waste: 'hazardous chemical waste',
			waste_electronic_appliances: 'waste electronic appliances',
			mobile_phone: 'mobile phone',
			battery: 'battery',
			old_tires_and_rubber: 'old tires and rubber',
			molding_machine: 'molding machine',
			stock_old_clothes: 'stock old clothes',
			clothing: 'clothing',
			shoes_and_Hats: 'shoes and Hats',
			waste_glass: 'waste glass',
			waste_wood: 'waste wood',
			Vehicle: 'Vehicle',
			land: 'land',
			house_property: 'house property'
		},
		recommend: {
			title: 'Recommend',
			used_equipment: 'used equipment',
			overstock_of_goods: 'overstock of goods',
			scrap_metal: 'scrap metal'
		},
		process: {
			title: 'process',
			step_1: {
				number: 'step 1',
				describe: 'Registration and certification'
			},
			step_2: {
				number: 'step 2',
				describe: 'Pre auction preparation'
			},
			step_3: {
				number: 'step 3',
				describe: 'Deposit'
			},
			step_4: {
				number: 'step 4',
				describe: 'Bidding'
			},
			step_5: {
				number: 'step 5',
				describe: 'Successful bidding'
			},
			step_6: {
				number: 'step 6',
				describe: 'Offline pickup'
			}
		},
		big_title: {
			special_auction: {
				title: 'SPECIAL AUCTION',
				auction_platform: 'auction platform:',
				current_price: 'current price',
				opening_time: 'opening time:',
				subject_address: 'subject address:'
			},
			closing_case: {
				title: 'CLOSING CASE',
				transaction_price: 'transaction price',
				closing_time: 'closing time'
			},
			enterprise: {
				title: 'ENTERPRISE',
				entry_time: 'entry time:'
			},
			recent_notice: 'RECENT NOTICE'
		},
		more: 'MORE>>'
	},
	// 标的
	subject: {
		subject_type: 'Subject Type:',
		subject_state: 'Subject State:',
		subject_address: 'Subject Address:',
		no_data: 'No Data',
		pagination: {
			first: 'First',
			last: 'Last',
			prev: 'Prev',
			next: 'Next',
			all: 'All',
			pages: 'Pages',
			record: 'Record'
		},
		list: {
			starting_price: 'starting price:',
			number: 'number:',
			auction_time: 'auction time:',
			subject_address: 'subject address:',
			sign_up: 'sign up',
			onlookers: 'onlookers',
			state: {
				s_1: 'Waiting',
				s_2: 'Underway',
				s_3: 'Finished'
			}
		}
	},
	// 标的详情
	subject_details: {
		enterprise: 'enterprise:',
		contact_information: 'contact information:',
		see_the_introduction_of_the_subject_for_the_large_drawing: 'see the introduction of the subject for the large drawing',
		payment_location_of_online_margin: 'payment location of online margin',
		current_price: 'current price',
		distance_start_time: 'distance start time:',
		sign_up: 'sign up',
		onlookers: 'onlookers',
		number: 'number',
		leading_number: 'leading number',
		your_number: 'your number:',
		auctioneers_speech: "auctioneer's speech",
		auctioneer_information: 'auctioneer information',
		state: 'state',
		bidding_number: 'bidding number',
		offer: 'offer',
		service_charge: 'The auction platform shall provide the auction service, and the comprehensive service fee shall be paid after the transaction, which shall be charged at the proportion of 3% of the transaction amount',
		starting_price: 'starting price:',
		deposit: 'deposit:',
		markup_range: 'markup range:',
		evaluation_price: 'evaluation price:',
		reserve_price: ' reserve price:',
		preemptive_right_holder: 'preemptive right holder:',
		free_bidding_time: 'free bidding time',
		time_limited_bidding_time: 'time limited bidding time:',
		opening_time: 'opening time:',
		please_pay_deposit_after_registration: 'please pay deposit after registration:',
		how_to_pay_the_deposit: 'how to pay the deposit?',
		bidding_rules: 'Bidding rules: one person signs up for bidding, and only when the transaction conditions are met can the transaction be concluded',
		final_payment_method: 'final payment method',
		offline_transaction: 'offline transaction',
		deadline_for_final_payment: 'deadline for final payment',
		within_3_working_days_after_the_transaction: 'within 3 working days after the transaction',
		introduction_of_subject_matter: 'INTRODUCTION OF SUBJECT MATTER',
		notice: 'NOTICE',
		bidding_notice: 'NOTICE',
		bidding_record: 'RECORD',
		enrollment_ended: 'Enrollment ended',
		no_data: 'No Data',
		day: 'day',
		hour: 'hour',
		min: 'min',
		s: 's',
		yes: 'yes',
		no: 'no',
		lead: 'lead',
		eliminate: 'eliminate',
		price: 'price',
		time: 'time',
	}
}